<script>
  import SinInformacion from "../Sin_informacion.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import Modal from "../../components/Modal.svelte"
  import { Datatable } from "svelte-simple-datatables"
  import Container from "../../components/Container.svelte"

  export let cliente

  let comentarios = []

  let comentario = {
    comentarios: "",
    agenda: [],
  }

  let agenda = {
    tipo_agenda: "",
    fecha_hora: "",
  }

  let isOpenModal = false
  let isOpenModalConfirm = false

  let isAddingComentario = false

  const settings = {
    sortable: true,
    pagination: true,
    rowsPerPage: 12,
    columnFilter: false,
    scrollY: false,
    blocks: {
      searchInput: false,
      paginationButtons: true,
      paginationRowCount: false,
    },
    labels: {
      previous: "Anterior",
      next: "Siguiente",
    },
  }

  let rows

  const getComentarios = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=getComentarios&id=${cliente.id}&session_key=${$user.session_key}`,
    )
    const data = await response.json()
    if (
      data.status === "ok" ||
      data.message === "No se encontraron resultados"
    ) {
      comentarios = data.data
    } else {
      console.error("Error al obtener comentarios:", data.message)
    }
  }

  const addComentario = async () => {
    if (comentario.comentarios === "") {
      alert("Por favor, complete todos los campos.")
      return
    }

    isAddingComentario = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "addComentario",
        id: cliente.id,
        ...comentario,
        session_key: $user.session_key,
      }),
    })

    const data = await response.json()
    if (data.status === "ok") {
      comentario = { comentarios: "", agenda: [] }
      isOpenModalConfirm = false
      getComentarios()
    } else {
      console.error("Error al agregar comentario:", data.message)
    }

    isAddingComentario = false
  }

  const addAgenda = async () => {
    if (agenda.tipo_agenda === "" || agenda.fecha_hora === "") {
      alert("Por favor, complete todos los campos.")
      return
    }
    comentario.agenda[0] = agenda
    addComentario()
    isOpenModal = false
  }

  const deleteCommentario = async (id_comentario) => {
    if (confirm("¿Estás seguro de que deseas eliminar este comentario?")) {
      const response = await fetch(`${BASE_URL}crm.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ops: "deleteComentario",
          id: cliente.id,
          id_comentario: id_comentario,
          session_key: $user.session_key,
        }),
      })
      const data = await response.json()
      if (data.status === "ok") {
        getComentarios()
      } else {
        console.error("Error al eliminar comentario:", data.message)
      }
    }
  }

  const handleAgregarAgenda = () => {
    isOpenModalConfirm = false
    isOpenModal = true
    agenda = { tipo_agenda: "", fecha_hora: "" }
  }

  const handleAgregarComentario = () => {
    isOpenModalConfirm = true
  }

  const cancelCommentario = () => {
    comentario = { comentarios: "", agenda: [] }
    agenda = {
      tipo_agenda: "",
      fecha_hora: "",
    }
  }

  const cancelAgenda = () => {
    agenda = { tipo_agenda: "", fecha_hora: "" }
    isOpenModal = false
  }

  $: if (cliente && cliente.id) {
    getComentarios()
  }
</script>

<Container>
  <h6 class="text-start">
    <i class="bi-chat-left-text fg-secondary me-3"></i> Comentarios
  </h6>
  <textarea
    class="form-control"
    rows="5"
    placeholder="Escribe un comentario..."
    bind:value={comentario.comentarios}
  ></textarea>
  <div class="d-flex justify-content-end mt-3 mb-5">
    <button
      class="btn btn-solid theme-primary btn-sm"
      on:click={handleAgregarComentario}>Guardar</button
    >
    <button
      class="btn btn-solid theme-secondary btn-sm ms-3"
      on:click={cancelCommentario}>Cancelar</button
    >
  </div>

  <Datatable {settings} data={comentarios} bind:dataRows={rows}>
    <table class="table table-striped table-xs">
      <thead>
        <tr>
          <th class="fg-secondary fw-normal">Fecha</th>
          <th class="fg-secondary fw-normal">Comentario</th>
          <th class="fg-secondary fw-normal">Tipo agenda</th>
          <th class="fg-secondary fw-normal">Fecha agenda</th>
          <th class="fg-secondary fw-normal"></th>
        </tr>
      </thead>
      <tbody>
        {#if rows}
          {#each $rows as comentario}
            <tr>
              <td
                >{String(comentario.fecha_registro ?? "").split(/[T\s]/)[0]}</td
              >
              <td>{comentario.comentarios}</td>
              <td>{comentario.tipo_agenda ?? ""}</td>
              <td>{comentario.fecha_hora ?? ""}</td>
              <td class="text-end">
                <button
                  class="btn btn-xs fg-danger py-0 my-0"
                  on:click={() => deleteCommentario(comentario.id)}
                  ><i class="bi bi-trash"></i></button
                >
              </td>
            </tr>
          {:else}
            <tr>
              <td colspan="5">
                <SinInformacion message="No hay comentarios para mostrar" />
              </td>
            </tr>
          {/each}
        {/if}
      </tbody>
    </table>
  </Datatable>
</Container>

<Modal
  isOpen={isOpenModal}
  on:close={() => (isOpenModal = false)}
  title="Agregar agenda"
>
  <div class="mb-3">
    <label for="tipo_agenda" class="form-label">Tipo de agenda</label>
    <select
      id="tipo_agenda"
      class="form-control form-control-sm"
      bind:value={agenda.tipo_agenda}
    >
      <option value="">Seleccionar</option>
      <option value="Llamada">Llamada</option>
      <option value="Reunión física">Reunión física</option>
      <option value="Reunión virtual">Reunión virtual</option>
    </select>
  </div>
  <div class="mb-3">
    <label for="fecha_hora" class="form-label">Fecha y hora de la agenda</label>
    <input
      type="datetime-local"
      id="fecha_hora"
      class="form-control form-control-sm"
      bind:value={agenda.fecha_hora}
    />
  </div>
  <div class="mb-3 text-end">
    {#if isAddingComentario}
      <button class="btn btn-solid theme-primary btn-sm" disabled>
        <i class="bi bi-save"></i> Guardando...
      </button>
      <button class="btn btn-solid theme-secondary btn-sm" disabled>
        <i class="bi bi-x"></i> Cancelar
      </button>
    {:else}
      <button class="btn btn-solid theme-primary btn-sm" on:click={addAgenda}
        ><i class="bi bi-save"></i> Guardar</button
      >
      <button
        class="btn btn-solid theme-secondary btn-sm"
        on:click={cancelAgenda}><i class="bi bi-x"></i> Cancelar</button
      >
    {/if}
  </div>
</Modal>

<Modal
  isOpen={isOpenModalConfirm}
  on:close={() => (isOpenModalConfirm = false)}
  title=""
>
  <h5 class="text-center">¿Deseas guardar este comentario?</h5>
  <div class="text-center py-3">
    {#if isAddingComentario}
      <button class="btn btn-solid theme-primary btn-sm me-3 disabled" disabled
        >Guardando...</button
      >
      <button class="btn btn-solid theme-warning btn-sm me-3 disabled" disabled
        >Agendar</button
      >
    {:else}
      <button
        class="btn btn-solid theme-primary btn-sm me-3"
        on:click={addComentario}>Guardar</button
      >
      <button
        class="btn btn-solid theme-warning btn-sm me-3"
        on:click={handleAgregarAgenda}>Agendar</button
      >
    {/if}
  </div>
</Modal>
